import qs from 'query-string';
import { get } from './baseApi';

export const ReportApi = {
    getBovinesByType: (query) => get(`/reports/bovines/type?${qs.stringify(query)}`),
    getBovinesByLot: (query) => get(`/reports/bovines/lot?${qs.stringify(query)}`),
    getBovinesByRegistration: (query) => get(`/reports/bovines/registration?${qs.stringify(query)}`),
    getAllCount: (query) => get(`/reports/count?${qs.stringify(query)}`),
};
